import { setupStorePolling } from "~/core/utilities/store-polling/setupStorePolling";
import { UNIQUE_IDENTIFIER, POLLING_NAMES, ACTIONS } from "./names";

export const POLLING_STORE_FUNCTIONS = setupStorePolling(
    POLLING_NAMES, 
    ACTIONS.LOAD_PROCESS_AND_SAVE_BINARY_DATA, 
    UNIQUE_IDENTIFIER,
);